import * as React from 'react'
import * as Tooltip from 'react-tooltip'
import { INestedProduct, IBaseProduct } from '@getgreenline/homi-shared'

interface Props {
  product: INestedProduct
}

interface State {
  showPopover: boolean
}

interface IComplianceError {
  label: string
}

function validateBaseProduct(product: IBaseProduct): IComplianceError[] {
  const complianceErrors: IComplianceError[] = []
  if (!product.trackInventory) {
    complianceErrors.push({
      label: `${product.name} is not tracking inventory`,
    })
  }
  if (!product.cannabisWeight) {
    complianceErrors.push({
      label: `${product.name} does not have a net product weight`,
    })
  }

  return complianceErrors
}

export class ComplianceBadge extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      showPopover: false,
    }
  }

  render() {
    const { product } = this.props

    // If a product doesn't have a compliance category, there's no need to display anything
    if (!product.complianceCategoryId) {
      return <span />
    }

    let complianceErrors: IComplianceError[] = []

    if (product.isMasterProduct) {
      // Variant products should be tracking inventory and have cannabis weights
      product.childProducts.forEach((cp) => {
        complianceErrors = [...complianceErrors, ...validateBaseProduct(cp)]
      })
    } else {
      complianceErrors = [...complianceErrors, ...validateBaseProduct(product)]
    }

    if (complianceErrors.length === 0) {
      return (
        <>
          <span className='fa fa-check blaze-text-primary mr-2' />
          <span>{product.complianceCategoryName}</span>
        </>
      )
    }

    const targetId = `${product.id}-compliance-badge`

    return (
      <div data-tip data-for={targetId}>
        <span className='fa fa-times blaze-text-danger mr-2' />
        <span>{product.complianceCategoryName}</span>
        <Tooltip id={targetId} place='bottom' effect='solid'>
          {complianceErrors.map((c, index) => {
            return <li key={index}>{c.label}</li>
          })}
        </Tooltip>
      </div>
    )
  }
}
